import renderViewer from './renderViewer';

const ui = {
    renderViewer
};

export { ui };
